"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

import { dropdownLabels } from "./EcommerceReassuranceBanner";

export const ecommerceReassuranceBannerInputs = [
  {
    name: "items",
    type: "list",
    copyOnAdd: false,
    required: true,
    subFields: [
      {
        name: "icon",
        type: "string",
        enum: dropdownLabels,
        required: true,
      },
      {
        name: "description",
        type: "string",
        required: true,
      },
      {
        name: "href",
        type: "url",
      },
    ],
    defaultValue: [
      {
        icon: "Package",
        description: "Free delivery from CHF 25.00",
      },
      {
        icon: "Package with clock",
        description: "Easy returns 30 days",
      },
      {
        icon: "Check + round",
        description: "2 years limited warranty",
      },
      {
        icon: "Credit card + lock",
        description: "Secure payments",
      },
    ],
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("items");
      if (Array.isArray(items) && items.length > 4) {
        options.set("items", items.slice(0, 4));
        alert("You can add maximum 4 items");
      }
    },
  },
] as const satisfies Inputs;

const EcommerceReassuranceBanner = dynamic(async () =>
  withValidation(
    ecommerceReassuranceBannerInputs,
    (await import("./EcommerceReassuranceBanner")).EcommerceReassuranceBanner,
    "EcommerceReassuranceBanner"
  )
);

export const EcommerceReassuranceBannerComponent: RegisteredComponent = {
  name: "EcommerceReassuranceBanner",
  component: EcommerceReassuranceBanner,
  inputs: ecommerceReassuranceBannerInputs,
};
